import React from 'react';

const EditingContainer = ({ onDone, children }) => (
  <div>
    {children}
    <div className="d-f jc-e ai-c mt-16">
      <button
        type="button"
        className="ml-16 NewButton NewButton--blue NewButton--wide NewButton--center"
        onClick={onDone}
        children="Done"
      />
    </div>
  </div>
);

export default EditingContainer;
